import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import EtherscanLink from './EtherscanLink';
import './AlertModal.css'; // We'll create this CSS file

interface AlertModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    type: 'success' | 'error';
    txHash?: string; // Optional transaction hash for successful transactions
}

const AlertModal: FC<AlertModalProps> = ({ isOpen, onClose, title, message, type, txHash }) => {
    const { t } = useTranslation();

    if (!isOpen) {
        return null;
    }

    return (
        <div className="alert-modal-overlay" onClick={onClose}>
            <div className={`alert-modal-content ${type}`} onClick={(e) => e.stopPropagation()}>
                <div className="alert-modal-header">
                    <h3 className="alert-modal-title">{title}</h3>
                    <button className="alert-modal-close-button" onClick={onClose}>×</button>
                </div>
                <div className="alert-modal-body">
                    <p>{message}</p>
                    {txHash && type === 'success' && (
                        <div className="transaction-link-section">
                            <p style={{ marginTop: '16px', marginBottom: '8px', fontWeight: 'bold' }}>
                                {t('alertModal.transactionDetails')}:
                            </p>
                            <EtherscanLink 
                                type="tx" 
                                hash={txHash} 
                                className="button tx-hash"
                            >
                                {t('alertModal.viewOnEtherscan')}
                            </EtherscanLink>
                        </div>
                    )}
                </div>
                <div className="alert-modal-footer">
                    <button className="alert-modal-ok-button" onClick={onClose}>OK</button>
                </div>
            </div>
        </div>
    );
};

export default AlertModal;